<template>
  <div class="APP-BOX clearfix">

    <div class="block_03 clearfix" :style="backImg">
      <div class="block-n_03 clearfix">
        <p v-if='edit == false'><span>尊敬的客户，</span>您的手机号码 <b>{{customer.mobile}}</b> 在我院系统中对应顾客为:</p>
        <p v-else><span>尊敬的客户，</span>您的手机号码 <b>{{customer.mobile}}</b> 在我院系统中不存在，请填写基本信息:</p>
      </div>

      <form class="form01">
        <!-- 南京分院需要选择 -->
        <div v-if="edit==true && (hosId==3 || hosId==2)">
          <span>医院</span>
          <input class="input04" name="" type="radio" value="3" v-model="customer.hos_id"
                 :disabled="edit==false"/><label>南京</label>
          <input class="input04" name="" type="radio" value="75" v-model="customer.hos_id"
                 :disabled="edit==false"/><label>扬州</label>
          <input class="input04" name="" type="radio" value="77" v-model="customer.hos_id"
                 :disabled="edit==false"/><label>常州</label>
        </div>
        <div>
          <span>姓名</span>
          <input class="input01" type="text" placeholder="" v-model="customer.customerName"
                                   :disabled="!canModifyCusName"></div>
        <div>
          <span>性别</span>
          <input class="input04" name="Fruit" type="radio" value="1" v-model="customer.gender"
                 :disabled="!canModifyCusName && customer.gender == '2'"/><label>男</label>
          <input class="input04" name="Fruit" type="radio" value="2" v-model="customer.gender"
                 :disabled="!canModifyCusName && customer.gender == '1'"/><label>女</label>
        </div>

        <div class="div001" v-if="srBtnActive == 0"> <!--  v-if='this.hosId == 2' -->
          <span>生日</span>
          <input class="input01" placeholder="请输入您的生日" type="text" @click="selectData" :readonly="true" :disabled="customer.birthday !== '' && !canModifyCusName" v-model="customer.birthday" />
          <a class="a01" @click="switchBirthday" v-show="hosId == birthdayHosId">手动输入</a>
        </div>

        <div class="div001" v-else-if="srBtnActive == 1">
          <span>生日</span>
          <input placeholder="年" class="input_sr" v-model="birthStr.year" /><label class="label01">-</label>
          <input placeholder="月" class="input_sr" v-model="birthStr.month" /><label class="label01">-</label>
          <input placeholder="日" class="input_sr" v-model="birthStr.day" />
          <a class="a01" @click="switchBirthday" v-show="hosId == birthdayHosId">选择输入</a>
        </div>

      </form>
      <div></div>
      <mt-datetime-picker
        v-model="dateVal"
        ref="picker"
        type="date"
        :startDate="startDate"
        :endDate="endDate"
        @touchmove.native.stop.prevent="function(){}"
        @confirm="handleConfirm">
      </mt-datetime-picker>

      <div class="htiao"></div>
      <ul class="ul01 clearfix" v-if='edit == false'>
        <li v-show="mzCodeShow"><span>门诊号</span>{{customer.mzCode}}</li>
        <li v-show="employeeNameShow" class="li01"><span>专职客管</span>{{customer.employeeName}}</li>
      </ul>


    </div>

    <div class="clear"></div>

    <div class="div03 clearfix" v-if='edit == false || hosId == tempHosId'>
      <div class="div03_1 clearfix">
        <span>省</span>
        <select class="" v-model="province" @change="getCities" :disabled="province!=='' && !canModifyCusName">
          <option disabled value="">请选择所在省</option>
          <option v-for="p in provinces" :value="p.id">{{p.regionName}}</option>
        </select>
      </div>
      <div class="div03_2 clearfix">
        <span>市</span>
        <select class="" v-model="city" :disabled="!canModifyCusName">
          <option disabled value="">请选择所在市</option>
          <option v-for="c in cities" :value="c.id">{{c.regionName}}</option>
        </select>
      </div>
    </div>

    <div class="tishi-b clearfix" v-if='edit == false'>
      <p>如果该号码不是您本人的请联系导医或者您的专职客管帮您解决您的号码绑定问题!谢谢配合!</p>
    </div>

    <div class="div03 clearfix" v-if='edit == false'>
      <a class="a04" @click="bind">确认绑定</a>
      <a class="a05" @click="closeWin">不这人不是我</a>
    </div>

    <div class="div03 clearfix" v-else>
      <!--<div class="div03_3 clearfix">
        <v-select placeholder="了解途径" multiple :options="informedWays" label="informedWayName" v-model="informedWay"
                  :reduce="informedWay => informedWay.id"></v-select>
      </div>-->
      <a class="a02" @click="regist">注册</a>
    </div>
  </div>
</template>

<script>
    import * as cookieUtil from '@/utils/cookieUtil'
    import customerService from '@/services/customer-service'
    import commonService from '@/services/common-service'
    import commonUtil from '../../utils/commonUtil'
    import {Toast, DatetimePicker, Field } from 'mint-ui'
    import wx from 'weixin-js-sdk'
    import regionService from '../../services/region-service'
    //import Vue from 'vue'
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css'
    //import informedWayService from '../../services/informed-service'
    // import "vue-select/src/scss/vue-select.scss";

    Vue.component('v-select', vSelect);
    Vue.component(Field.name, Field);

    export default {
        data () {
            return {
                backImg: commonUtil.setBackImg('top-0'), // 根据医院ID更换背景图片
                hosId: parseInt(cookieUtil.get('hospitalId')),
                tempHosId: 8, // 奇致要求填的比较多
                birthdayHosId: 7, // 给长沙做的生日可选可输入
                edit: this.$route.query.edit, // 判断是新顾客，还是老顾客
                canModifyCusName: this.$route.query.canModifyCusName, // 是否可以修改姓名
                disable: false,
                token: cookieUtil.get('token') || '',
                sequenceKey: this.$route.query.sequenceKey || '',
                mzCodeShow: false,
                employeeNameShow: false,
                dateVal: '',
                customer: {
                    id: '',
                    mobile: this.$route.query.mobile || '',
                    customerName: '',
                    gender: '',
                    birthday: '',
                    age: '',
                    mzCode: '',
                    employeeName: '',
                    hos_id: '',
                },
                openId: this.$route.query.openId || '',
                startDate: new Date('1930-01-01'),
                endDate: new Date(),
                provinces: [],
                cities: [],
                province: '',
                city: '',
                selectCityDisabled: 'disabled',
                srBtnActive: 0,
                birthStr: {
                    year: '',
                    month: '',
                    day: '',
                },
                btnBindState: 0,
                btnRegistState: 0,
                /*informedWays: [],
                informedWay: []*/
            }
        },
        methods: {
            selectData () {
                if (this.customer.birthday) {
                    this.dateVal = new Date(this.customer.birthday);
                } else {
                    this.dateVal = new Date();
                    this.dateVal.setFullYear(1970,6,1);
                }
                this.$refs.picker.open();
            },
            switchBirthday () {
                if (this.srBtnActive == 1) {
                    this.srBtnActive = 0;
                } else {
                    this.srBtnActive = 1;
                }

            },
            bind () {
                if (this.btnBindState == 1) {
                    Toast('请勿重复提交，若等待过长时间，请刷新后尝试');
                    return;
                }
                this.btnBindState = 1;
                if (!this.validateProcess()) {
                    this.btnBindState = 0;
                    return;
                }
                // console.log('srBtnActive:' + this.srBtnActive);
                if (this.srBtnActive == 1){
                    if (this.checkBirthday()) {
                        this.customer.birthday = this.birthStr.year + '-' + this.birthStr.month + '-' + this.birthStr.day;
                    } else {
                        this.btnBindState = 0;
                        return;
                    }
                }
                let formData = new FormData();
                formData.append('appId', commonUtil.getAppId());
                formData.append('openId', this.openId);
                formData.append('customerId', this.customer.id);
                formData.append('customerName ', this.customer.customerName);
                formData.append('hos_id ', this.customer.hos_id);
                formData.append('mobile', this.customer.mobile);
                formData.append('birthday', this.customer.birthday);
                formData.append('provinceId', this.province);
                formData.append('cityId', this.city);
                formData.append('key', this.sequenceKey);
                customerService.wxBind(formData).then((res) => {
                    if (res.statusCode == 200) {
                        cookieUtil.set('token', res.data.token);
                        this.$router.push(cookieUtil.get('redirectUrl'));
                    } else {
                        this.btnBindState = 0;
                        Toast(res.message);
                    }
                }).catch((err) => {
                    this.btnBindState = 0;
                    console.log(err);
                })
            },
            regist () {
                if (this.btnRegistState == 1) {
                    Toast('请勿重复提交，若等待过长时间，请刷新后尝试');
                    return;
                }
                this.btnRegistState = 1;
                if (!this.validateProcess()) {
                    this.btnRegistState = 0;
                    return;
                }
                console.log(this.customer.hos_id);
                let formData = new FormData();
                formData.append('appId', commonUtil.getAppId());
                formData.append('openId', this.openId);
                formData.append('customerName', this.customer.customerName);
                formData.append('hos_id ', this.customer.hos_id);
                formData.append('mobile', this.customer.mobile);
                formData.append('gender', this.customer.gender);
                formData.append('birthday', this.customer.birthday);
                formData.append('provinceId', this.province);
                formData.append('cityId', this.city);
                //formData.append('informedWayIds', this.informedWay.join(','))
                formData.append('key', this.sequenceKey);
                customerService.registCustomer(formData).then((res) => {
                    if (res.statusCode == 200) {
                        cookieUtil.set('token', res.data.token);
                        this.$router.push(cookieUtil.get('redirectUrl'));
                    } else {
                        this.btnRegistState = 0;
                        Toast(res.message);
                    }
                }).catch((err) => {
                    this.btnRegistState = 0;
                    console.log(err);
                })

            },
            openPicker () {
                this.$refs.picker.open();
            },
            handleConfirm (data) {
                this.customer.birthday = this.getDate(data);  //获取的时间为时间戳
                console.log(this.customer.birthday);
            },
            getDate (data) {
                const time = new Date(data);
                let month = time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1;
                let date = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
                return time.getFullYear() + '-' + month + '-' + date;
            },
            checkBirthday () {
                let regYear =/^(19|20)\d{2}$/;
                let regMonth = /^((0?[1-9])|(1[0-2]))$/;
                let regDay = /^((0?[1-9])|([1-2][0-9])|30|31)$/;
                let smallMonth = /^((0?[469])|11)$/; // 大小月判断

                let iYear = parseInt(this.birthStr.year);
                let iMonth = parseInt(this.birthStr.month);
                let iDay = parseInt(this.birthStr.day);

                if (!regYear.test(this.birthStr.year)) {
                    Toast('生日年份示例: 19XX，20XX');
                    return false;
                }
                if (!regMonth.test(this.birthStr.month)) {
                    Toast('生日月份范围: 1-12');
                    return false;
                }
                if (!regDay.test(this.birthStr.day)) {
                    Toast('生日日期范围: 1-31');
                    return false;
                }
                if(smallMonth.test(this.birthStr.month) &&　this.birthStr.day == '31') {
                    Toast(iMonth + '月最多只有30天');
                    return false;
                }
                // 如果是2月份，那么判断年份是闰年还是平年，闰年29天，平年28天
                // 能被4整除的年份是闰年，不能被4整除的年份是平年。但是如果是整百年，就只有能被400整除才是闰年，否则就是平年。

                console.log('年:'+ iYear);
                console.log('月:'+ iMonth);
                console.log('日:'+ iDay);
                if(iMonth == 2){
                    if(iYear % 4 == 0 || (iYear % 100 == 0 && iYear % 400 == 0)) {
                        // 闰年
                        if(iDay > 29 ) {
                            Toast('闰年2月份最多有29天');
                            return false;
                        }
                    } else if(iDay > 28 ) {
                        Toast('平年2月份最多有28天');
                        return false;
                    }
                }
                this.birthStr.month = iMonth < 10 ? '0' + iMonth : iMonth;
                this.birthStr.day = iDay < 10 ? '0' + iDay : iDay;
                return true;
            },
            closeWin () {
                wx.closeWindow();
            },
            getCities(cc){
                this.city = '';
                console.log(this.province);
                if (this.province !== '') {
                    const params = {
                        provinceId: this.province,
                    }
                    regionService.getCities(params).then((res) => {
                        if (res.statusCode == 200) {
                            this.cities = res.data;
                            this.selectCityDisabled = false;
                            if (cc) {
                                this.city = cc;
                            }
                        } else {
                            console.log(res.message);
                            Toast('获取城市失败');
                        }
                    }).catch((err) => {
                        console.log(err);
                    })
                } else {
                    this.cities = []
                }
            },
            validateProcess() {
                // 通用判断，顾客姓名不能为空
                if (!this.customer.customerName) {
                    Toast('请输入您的姓名');
                    return false;
                } else {
                    // 中文，英文，下划线
                    let customerNameRegx = /^[\u4E00-\u9FA5A-Za-z_]+$/;
                    if (!customerNameRegx.test(this.customer.customerName)) {
                        Toast('顾客姓名只能由中英文和下划线组成');
                        return false;
                    } else if (this.customer.customerName == '某' || this.customer.customerName == '某某'
                        || this.customer.customerName == '某某某' || this.customer.customerName == '某某某某') {
                        // 顾客姓名，只能输入中英文和下划线，不能是，”某“， “某某”， “某某某”
                        Toast('请填写您的真实姓名');
                        return false;
                    }
                }
                if (this.hosId == this.tempHosId) {
                    if (!this.customer.gender) {
                        Toast('请选择性别');
                        return false;
                    } else if (!this.customer.birthday) {
                        Toast('请选择您的生日');
                        return false;
                    } else if (!this.province) {
                        Toast('请选择所在省');
                        return false;
                    } else if (!this.city) {
                        Toast('请选择所在市');
                        return false;
                    }
                }
              if (this.hosId == 7) {
                console.log('srBtnActive:' + this.srBtnActive);
                if (this.srBtnActive == 1){
                  if (this.checkBirthday()) {
                    this.customer.birthday = this.birthStr.year + '-' + this.birthStr.month + '-' + this.birthStr.day;
                  } else {
                    return false;
                  }
                }
              }
              return true;
            }
        },
        created () {
            console.log('edit:', this.edit);
            console.log('edit==false:', this.edit == false);
            console.log('canModifyCusName:', this.canModifyCusName);
            console.log('birthday:', this.customer.birthday);
            console.log('hosId:', this.hosId);
            regionService.getProvinces().then((res) => {
                if (res.statusCode == 200) {
                    this.provinces = res.data
                } else {
                    console.log(res.message);
                    Toast('获取省失败');
                }
            }).catch((err) => {
                console.log(err)
            })
            /*informedWayService.getInformedWay().then((res) => {
                if (res.statusCode == 200) {
                    this.informedWays = res.data
                } else {
                    console.log(res.message)
                    Toast('获取了解途径失败')
                }
            }).catch((err) => {
                console.log(err)
            })*/
            // 系统存在顾客
            if (this.edit == false) {
                this.disable = 'disable';
                const params = {
                    mobile: this.customer.mobile
                };
                customerService.getCustomerInfoByMobile(params).then((res) => {
                    if (res.statusCode == 200) {
                        this.customer.id = res.data.id;
                        this.customer.customerName = res.data.customerName;
                        this.customer.gender = res.data.gender;
                        this.province = res.data.provinceId;
                        if (this.province) {
                            this.getCities(res.data.cityId);
                        }
                        if (res.data.birthday != null) {
                            const time = new Date(res.data.birthday);
                            let month = time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1;
                            let date = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
                            this.customer.birthday = time.getFullYear() + '-' + month + '-' + date;
                            // this.birthdayShow = true
                        }
                        this.customer.age = res.data.age;
                        if (res.data.mzCode != null) {
                            this.customer.mzCode = res.data.mzCode;
                            this.mzCodeShow = true
                        }
                        if (res.data.employeeName != null) {
                            this.customer.employeeName = res.data.employeeName;
                            this.employeeNameShow = true
                        }
                    }
                }).catch((err) => {
                    console.log(err)
                })
            }

            let formData = new FormData();
            formData.append('url', location.href.split('#')[0]);
            commonService.getWXJSAPISignature(formData).then((res) => {
                if (res.statusCode == 200) {
                    wx.config({
                        // debug: true, // 开启调试模式,
                        appId: commonUtil.getAppId(), // 必填，企业号的唯一标识，此处填写企业号corpid
                        timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                        nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                        signature: res.data.signature,// 必填，签名，见附录1
                        jsApiList: ['closeWindow'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                    })
                }
            })
        }
    }
</script>

<style lang="scss" scoped>
  .block_03 .form01 div input {
    color: #000;
  }

  .div03_1, .div03_2 {
    height: 70px;
  }

  .div03_1, .div03_2, .div03_3 {
    border-bottom: 1px solid #e8e8e8;
    font-size: 18px;
    line-height: 70px;
    margin: 0px auto;
    span {
      margin-left: 20px;
      display: block;
      float: left;
      width: 15%;
    }
    .span001 {
      margin-left: 0px;
      width: 25%;
    }
    select {
      background-color: white;
      line-height: 55px;
      border: 1px solid #EBEBEB;
      width: 60%;
      text-indent: 1em;
      color: #636363;
      font-size: 14px;
      border-radius: 10px;
      height: 50px;
      text-align: right;
    }
  }

  .div03 {
    margin-top: 0px;
  }

  .div03_3 {
    margin-top: 20px;
    margin-bottom: 20px;
    ::placeholder {
      color: #999;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/customer/Customer.vue